import { application } from "./application"

import CarouselController from "./carousel_controller"
import CheckAllController from "./check_all_controller"
import ClipboardController from "./clipboard_controller"
import CountdownController from "./countdown_controller"
import DropdownController from "./dropdown_controller"
import FilterController from "./filter_controller"
import HelloController from "./hello_controller"
import LoadMoreController from "./load_more_controller"
import MoneyMaskController from "./money_mask_controller"
import NestedSelectController from "./nested_select_controller"
import ShopeeImportController from "./shopee_import_controller"
import ToggleController from "./toggle_controller"

application.register("carousel", CarouselController)
application.register("check-all", CheckAllController)
application.register("clipboard", ClipboardController)
application.register("countdown", CountdownController)
application.register("dropdown", DropdownController)
application.register("filter", FilterController)
application.register("hello", HelloController)
application.register("load-more", LoadMoreController)
application.register("money-mask", MoneyMaskController)
application.register("nested-select", NestedSelectController)
application.register("shopee-import", ShopeeImportController)
application.register("toggle", ToggleController)
